'use client'

import { createContext, useContext } from 'react'

/** Reads the stage's current scale (the page fits the 1024px stage to its column). */
export type ReadStageScale = () => number

const readUnscaled: ReadStageScale = () => 1

const AppVisualScaleContext = createContext<ReadStageScale>(readUnscaled)

/** Set by `AppVisual` around its scene; the Paper lab renders at 1:1. */
export const AppVisualScaleProvider = AppVisualScaleContext.Provider

/**
 * The stage scale for components that map pointer coordinates into their own
 * space (the editor's selection overlay reads it as its canvas zoom): the
 * stage is CSS-scaled, so a client rect is `scale` times its layout size.
 */
export function useReadStageScale(): ReadStageScale {
  return useContext(AppVisualScaleContext)
}
